// extracted by mini-css-extract-plugin
export default {"imageWrapper":"kO-z","twoColumnImage":"lO-z"};